import { FormHelperText, styled } from "@tm/components"

export const FormHelperTextInline = styled(FormHelperText)(() => ({
    position: "absolute",
    top: "calc(50% - 1em)",
    right: "0",
}))
